import { required } from 'vuelidate/lib/validators'

export default {
  employee: {
    staff_id: {
      required
    },
    company_address_id: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/form/resources/validations.js